/**
 * NotificationSystem - Sistema de notificações
 */
import React, { useState, useEffect, createContext, useContext } from 'react'

const NotificationContext = createContext()

export const useNotifications = () => useContext(NotificationContext)

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([])

  const addNotification = (notification) => {
    const id = Date.now()
    const newNotification = {
      id,
      ...notification,
      timestamp: new Date()
    }
    setNotifications(prev => [...prev, newNotification])

    // Auto-remover após timeout
    if (notification.autoClose !== false) {
      setTimeout(() => {
        removeNotification(id)
      }, notification.duration || 5000)
    }

    return id
  }

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id))
  }

  const clearAll = () => {
    setNotifications([])
  }

  return (
    <NotificationContext.Provider value={{ notifications, addNotification, removeNotification, clearAll }}>
      {children}
      <NotificationContainer />
    </NotificationContext.Provider>
  )
}

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotifications()

  return (
    <div className="notification-container">
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          notification={notification}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  )
}

const Notification = ({ notification, onClose }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const handleClose = () => {
    setIsVisible(false)
    setTimeout(onClose, 300) // Delay para animação
  }

  return (
    <div
      className={`notification notification-${notification.type || 'info'} ${isVisible ? 'visible' : ''}`}
    >
      <div className="notification-icon">
        {notification.type === 'success' && '✅'}
        {notification.type === 'error' && '❌'}
        {notification.type === 'warning' && '⚠️'}
        {notification.type === 'info' && 'ℹ️'}
      </div>
      <div className="notification-content">
        <h4>{notification.title}</h4>
        {notification.message && <p>{notification.message}</p>}
        {notification.actions && (
          <div className="notification-actions">
            {notification.actions.map((action, index) => (
              <button key={index} onClick={action.onClick}>
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <button className="notification-close" onClick={handleClose}>
        ×
      </button>
    </div>
  )
}

export default NotificationProvider

